import {handicaddieAsyncThunk} from "../../asyncThunk";
import {RefreshSessionActionPayload, SessionState} from "./slice";
import {api, ApiError, ErrorResponse, getApiError} from "../../../ApiClient";
import {AxiosError} from "axios";
import {UserService} from "../../../api/UserService";

export const TOKEN_LOCAL_STORAGE_KEY = 'token';

export const refreshSession = handicaddieAsyncThunk("refreshSession", async (_, thunkAPI): Promise<RefreshSessionActionPayload> => {
    const onRejected = () => {
        return async (r: AxiosError<any, any>): Promise<AxiosError<any>> => {
            let errorResponse: ApiError = getApiError(r);
            if (errorResponse?.code === 'E0001') {
                thunkAPI.dispatch(handleInvalidToken())
            }
            return r;
        };
    }

    let t = localStorage.getItem(TOKEN_LOCAL_STORAGE_KEY);
    if (!t) {
        return {
            sessionState: SessionState.INACTIVE
        }
    }

    api.interceptors.request.use((r) => {
        if (!r.headers.Authorization) {
            r.headers.Authorization = t
        }
        return r;
    })
    api.interceptors.response.use((r) => {
        return r;
    }, onRejected())


    let usr = await UserService().getCurrentUser();
    if (!usr.user) {
        let err: ErrorResponse | undefined = usr.error;
        if (err?.apiError?.code === 'E0001') {
            // errorCallback will handle this...
            return {};
        }
        return {
            sessionState: SessionState.NO_PROFILE,
            token: t
        };
    }

    return {
        sessionState: SessionState.ACTIVE,
        token: t,
        user: usr.user
    }
});

export const handleInvalidToken = handicaddieAsyncThunk("handleInvalidToken", async (_, thunkAPI): Promise<SessionState> => {
    let token = thunkAPI.getState().session.token;
    if (!token || token.length === 0) {
        return SessionState.INACTIVE;
    }

    return SessionState.INACTIVE;
    // renewSession
});
